import React from 'react'
import Popup from 'react-popup';
import NavBar from './NavBar';
import SEO from '../components/SEO'
import Revolution from './Revolution';
import Sales from './Sales';
// import SoftwareDevelopment from './Services/SoftwareDevelopment';
// import RoboticsAutomation from './Services/RoboticsAutomation';
import OurServices from './OurServices';
import ContactForm from './ContactForm';
import About from './About';

class Main extends React.Component {

    render() {
      return (

      <>
        <Popup />

        <NavBar/>

        <Revolution/>

        <Sales/>

        <OurServices/>

        <About/>

        {/* <SoftwareDevelopment/> */}

        {/* <RoboticsAutomation/> */}

        <ContactForm/>

        <Sales/>
        
        <SEO/>
      </>
      )
    }
  }

  export default Main;
